import Countdown from 'react-countdown'

import { useTranslation } from '@/shared/hooks/useTranslation'

type QuestAvailabilityStateProps = {
  mode: 'soon' | 'closed'
  startAt?: string | null
  onOpen: () => void
}

export function QuestAvailabilityState({ mode, startAt, onOpen }: QuestAvailabilityStateProps) {
  const { t } = useTranslation()

  if (mode === 'closed') {
    return (
      <div className="flex flex-col items-center gap-2 text-center">
        <p className="m-0 text-sm font-bold text-gray-900">{t('quests.availability.closedTitle')}</p>
        <p className="m-0 text-xs text-gray-500">{t('quests.availability.closedDescription')}</p>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center gap-2 text-center">
      <p className="m-0 text-sm font-bold text-gray-900">{t('quests.availability.soonTitle')}</p>
      <p className="m-0 text-xs text-gray-500">{t('quests.availability.soonDescription')}</p>
      {startAt && (
        <Countdown date={startAt} onComplete={onOpen} />
      )}
    </div>
  )
}
